module.exports = __webpack_public_path__ + "static/media/spid-idp-timid~FIiWQnSz.b7e584e0.svg";